import { useMediaQuery, useTheme } from '@mui/material';

export const useDeviceType = () => {
  const theme = useTheme();
  
  // md 이하(900px 미만) 모바일/태블릿 화면 크기인지 확인
  const isMobileSize = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // PWA (standalone 모드)로 실행되었는지 확인
  const isPWA = window.matchMedia('(display-mode: standalone)').matches;
  
  // PC 브라우저에서 화면을 줄이거나(md 이하), PWA로 켰을 때 모두 모바일 뷰로 렌더링
  const isMobileApp = isPWA || isMobileSize;

  return {
    isMobileApp,
    isPWA,
    isSmallMobile,
    isMobileSize
  };
};
